import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { restoreAll } from '../restoreAll';
export interface Example {
    title: string;
    content: string;
}

export interface ExampleState {
    value: Example[];
}

const initialState: ExampleState = {
    value: [],
};

export const exampleSlice = createSlice({
    name: 'counter',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        addExample: (state, action) => {
            state.value.push(action.payload);
        },
        deleteExample: (state, action) => {
            state.value = state.value.filter(example => example.title !== action.payload);
        },
    },
});

export const { addExample, deleteExample } = exampleSlice.actions;

export const selectExample = (state: RootState) => state.example.value;

export default exampleSlice.reducer;
